<template>
  <div>
    <div
      v-if="getBadgeText(date)"
      class="h-5 px-2 flex items-center rounded-xl text-white text-xs"
      :style="`border: solid 1px ${getBadgeText(date)!.borderColor}; background-color: ${getBadgeText(date)!.color}; color: ${getBadgeText(date)!.textColor}`"
    >
      {{ getBadgeText(date)!.text }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { EventDate } from '~/composables/types/event'

const props = defineProps<{
  date: EventDate
}>()

const { t } = useI18n()

const getBadgeText = (date: EventDate) => {
  if (eventDateGetters.getAvailableTicketsQuantity(date) <= 4) {
    return {
      color: '#FF6A392E',
      textColor: '#0c0a09',
      borderColor: '#F58C60',
      text: t('product.show.timeSlots.sellingOutBadgeText'),
    }
  }
}
</script>
